var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-modal',{attrs:{"centered":"","size":"lg","ok-title":_vm.txtAccept,"cancel-title":_vm.txtCancel,"ok-only":_vm.onlyOk,"title":_vm.title},on:{"ok":_vm.onAccept,"cancel":_vm.onDecline,"hidden":_vm.onDecline},model:{value:(_vm.isOpen),callback:function ($$v) {_vm.isOpen=$$v},expression:"isOpen"}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.message)}})])],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f81b316","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/base/modalInfo.vue
// module id = null
// module chunks = 